import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FollowButtonComponent } from '@recruitee/candidate-ui';
import { TranslatePipe } from '@recruitee/i18n';
import type { Requisition } from '@recruitee/requisitions-types';
import { RequisitionStatus } from '@recruitee/requisitions-types';
import {
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  GroupComponent,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-requisition-table-row-actions',
  styleUrls: ['./requisition-table-row-actions.component.less'],
  templateUrl: './requisition-table-row-actions.component.html',
  imports: [
    IconButtonComponent,
    GroupComponent,
    DropdownComponent,
    DropdownItemComponent,
    IconComponent,
    ConnectedOverlayDirective,
    TranslatePipe,
    OverlayOriginDirective,
    FollowButtonComponent,
  ],
})
export class RequisitionTableRowActionsComponent {
  @Input() public requisition: Requisition;
  @Input() public canEditRequisition: boolean;

  @Output() public follow: EventEmitter<number> = new EventEmitter();
  @Output() public unfollow: EventEmitter<number> = new EventEmitter();
  @Output() public cancelRequest: EventEmitter<number> = new EventEmitter();
  @Output() public duplicate: EventEmitter<number> = new EventEmitter();
  @Output() public delete: EventEmitter<Requisition> = new EventEmitter();
  @Output() public archive: EventEmitter<Requisition> = new EventEmitter();
  @Output() public retrieve: EventEmitter<Requisition> = new EventEmitter();
  @Output() public openRequisition: EventEmitter<number> = new EventEmitter();

  public DropdownWidth = DropdownWidth;
  public RequisitionStatus: typeof RequisitionStatus = RequisitionStatus;
}
